
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CommissionService from "@/services/auth/CommissionService";
import ActionService from "@/services/lead/ActionService";
import RankingService from "@/services/auth/RankingService";
import HeroService from "@/services/auth/HeroService";
import vSelect from "vue-select";
import OnlineAttendantsList from "@/components/OnlineAttendantsList.vue";
import { Money } from "v-money";
import UserService from "@/services/auth/UserService";
import NotificationService from "@/services/NotificationService";
import ProfileService from "@/services/auth/ProfileService";
import { mapGetters } from "vuex";

@Component({
  components: {
    vSelect,
    OnlineAttendantsList,
    Money,
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  },
})

export default class BaseNavBar extends Vue {
    @Prop(Number) readonly userGoal: number | undefined | null;

  private showCommission = JSON.parse(this.$cookies.get("showCommission")) || true;
  private isEditCommissionGoal = false;
  private commissionGoal = '';
  private dailyCommission = null;
  private monthlyCommission = null;
  private allowedFeature: any;
  private commissionBySquad: any = null;
  private commissionSquadView: any = null;
  private rankingList:any = [];
  private rankingNivel:string = "geral";
  private myIndex:number = 0;
  private rankingListLen:number = 0;
  private onList = null;
  private actions = null;
  private loading = false;
  private heroQuadrant = 'quadrant_0';
  private progressQuadrant = 0;
  private isHero = false;
  private isGoldenDay = false
  private text1CSAT = '';
  private text2CSAT = '';
  private text1Conversion = '';
  private text2Conversion = '';
  private text1ProductiveContact = '';
  private text2ProductiveContact = '';
  private avatar:string = '';
  private quillOptions = {
    placeholder: 'Digite a notificação aqui',
    modules: {
        toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            // { 'list': 'ordered'},
            { 'list': 'bullet' },
            'link',
            'emoji',
            // { 'color': [] },
            // { 'background': [] }
        ],
        "emoji-toolbar": true,
        "emoji-textarea": false,
        "emoji-shortname": true,
    }
  }

  private pathAvatarSuffix:string = process.env.NODE_ENV === 'development'
    ? 'development'
    : 'production';

  // Notifications

  private notifAdmins = ['admin']
  private notifAdminIds = [
    5, // ana abreu
    23, // daniel
    24, // rodolfo
    34, // pamela reis
    46, // bruno papi
    61, // thuanny
    62, // lucas moreira
    64, // jordana
    81, // estela tavares
    266, // rodrigo loiola
    802, // carla campos
    827, // limao
    1011, // bruna campos
    1130, // nany
    1296, // flavinho
    1381, // bianca carvalho
    1525, // tamis
    1620, // beatriz lazzarini
    1622, // marcelo colleoni
  ]

  private isNotifAdmin =
    this.notifAdmins.includes(this.$auth.user().profile) ||
    this.notifAdminIds.includes(this.$auth.user().id_user)

  private notifTypes: any = [
    {value: "ALL", text: "Todos"},
    {value: "HERO", text: "Heroes"},
    {value: "OPERATOR", text: "Consultores"},
    {value: "STAFF", text: "Staff"},
    {value: "PLATFORM", text: "Cliente B2B"},
  ]

  private notifGroups: any = [];

  private selected = {
    type: "",
    groups: []
  };

  private selectedLabelType = ""
  private selectedLabelGroups: any[] = []

  private notifsInfo = {
    isCreate: false,
    isEdit: false,
    unread: 0,
  }

  private focusedMsgId: number | undefined = undefined;

  private notifications: any[] = [];

  private newNotifMsg = ''
  private notifWarning = ''

  private loadingNotif = false;
  private askingConfirmDelete = false;

  private keepNotificationsOpen () {
    let notif = document.getElementById('notifications-btn')
    if (notif) notif.focus()
  }

  private openCreateNotif () {
    this.keepNotificationsOpen()
    this.notifsInfo.isCreate = true
  }

  private openEditNotif (id: number, body: string, type: string, platforms: any) {
    this.notifsInfo.isEdit = true
    this.focusedMsgId = id
    this.newNotifMsg = body
    this.selected.type = type
    this.selected.groups = platforms
  }

  private cancelNewNotif () {
    this.notifsInfo.isCreate = false
    this.notifsInfo.isEdit = false
    this.newNotifMsg = ''
    this.notifWarning = ''
  }

  private getNotifBadges (msgTypeStr: string, msgGroupsArr: any) {
    let badges: any[] = []
    let typeText: string = '';

    let typeObj = this.notifTypes.find(e => e.value === msgTypeStr)
    if (typeObj) {
        typeText = typeObj.text
        badges.push(typeText)
    }

    let groupObjs: any[] = [];

    msgGroupsArr.forEach(selectedGroupElement =>
        groupObjs.push(
            this.notifGroups.find(
                e => e.value === selectedGroupElement
            )
        )
    )

    // delete all undefined or null elements
    groupObjs = groupObjs.filter(obj => obj)

    // alphabetical sort
    groupObjs.sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()))

    groupObjs.forEach(e => badges.push(e.text))

    return badges
  }

  private async setLastViewed () {
    this.notifsInfo.unread = 0;
    const notificationService = new NotificationService();
    await notificationService.setLastViewed();
  }

  private async getActivePlatforms () {
    const profileService = new ProfileService()

    const res = await profileService.getPlatform()
    let body = res.body

    body.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

    this.notifGroups = res.body.map(item => {
        return {
            value: item.id,
            text: item.name
        };
    });
  }

  private async getNotifications () {
    this.loadingNotif = true
    this.notifications = []
    const notificationService = new NotificationService();

    let unreadCount = 0;
    this.notifications = await notificationService.getNotifications();

    for (let i = 0; i < this.notifications.length; i++) {
        if (this.notifications[i].isRead === false) {
            unreadCount++
        }

        const today = Intl.DateTimeFormat('pt-BR', {day: 'numeric', month: 'numeric', year: '2-digit'}).format(new Date())
        const msgDate = Intl.DateTimeFormat('pt-BR', {day: 'numeric', month: 'numeric', year: '2-digit'}).format(new Date(this.notifications[i].created_at))
        const msgTime = Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(this.notifications[i].created_at))

        if (String(msgDate) === String(today)) {
            this.notifications[i].created_at = `${msgTime} | Hoje`
        } else {
            this.notifications[i].created_at = `${msgTime} | ${msgDate}`
        }

        this.notifications[i].badges = this.getNotifBadges(this.notifications[i].to, this.notifications[i].platforms)
    }
    this.notifsInfo.unread = unreadCount
    this.loadingNotif = false
  }

  private async submitNewNotification (body: string, type: string, platforms: number[]) {
    let platformsArr: any[] = [];
    this.notifWarning = '';
    if (!body || !type) {
        this.notifWarning = 'Mensagem e Tipo não podem ser vazios'
        return false
    }

    if (platforms.length === 0) {
        for (let i = 0; i < this.notifGroups.length; i++) {
            platformsArr.push(this.notifGroups[i].value)
        }
    } else {
        platformsArr = platforms
    }

    const params = {
        notificationBody: body,
        to: type,
        platforms: platformsArr,
    }

    this.loadingNotif = true
    const notificationService = new NotificationService()

    const newNotification = await notificationService.newNotification(params);
    await this.getNotifications()

    this.notifsInfo.isCreate = false
    this.newNotifMsg = ''
    this.loadingNotif = false
  }

  private async submitEditNotification (msgId: number, body: string, type: string, platforms: number[]) {
    let platformsArr: any[] = [];
    this.notifWarning = '';

    if (!body || !type) {
        this.notifWarning = 'Mensagem e Tipo não podem ser vazios'
        return false
    }

    if (platforms.length === 0) {
        for (let i = 0; i < this.notifGroups.length; i++) {
            platformsArr.push(this.notifGroups[i].value)
        }
    } else {
        platformsArr = platforms
    }

    const params = {
        notificationId: msgId,
        notificationBody: body,
        to: type,
        platforms: platformsArr,
    }

    this.loadingNotif = true;
    const notificationService = new NotificationService();

    await notificationService.updateNotification(params)
    await this.getNotifications()

    this.notifsInfo.isEdit = false
    this.newNotifMsg = ''
    this.loadingNotif = false;
  }

  private askConfirmDeleteNotif (id: number) {
    this.askingConfirmDelete = true
    this.focusedMsgId = id
  }

  private cancelDeleteNotif () {
    this.askingConfirmDelete = false;
    this.focusedMsgId = undefined
  }

  private async deleteNotification(id: number) {
    this.notifWarning = '';
    if (!id) {
        this.notifWarning = 'Erro ao identificar ID de mensagem'
        return false
    }

    this.loadingNotif = true;
    const notificationService = new NotificationService();

    await notificationService.deleteNotification(id);
    await this.getNotifications()
    this.loadingNotif = false;
  }


  //Default heroMetrics
  private heroMetrics:any = {
    csat: {
        current: 0,
        metric: 0,
        quadrant: ""
    },
    conversion: {
        current: 0,
        metric: 0,
        quadrant: ""
    },
    productiveContact: {
        current: 0,
        metric: 0,
        quadrant: ""
    },
    hero: false,
    quadrant: "",
    action: ""
  }

  private get profile() {
    return this.$auth.user().email.split("@")[0];
  }

  private get progressBarMax() {
      return this.commissionBySquad[this.commissionSquadView].commission_rule.find(e => e.trigger === 'gold').trigger_value;
  }

  private logout() {
    this.$cookies.remove("tokenValidity");

    this.$auth.logout();
  }

  private menuSidebar() {
    this.$emit("toogleSidebar");
  }

  private toPlatform() {
    this.$router.push('/platform');
  }

  private editCommissionGoal () {
    this.isEditCommissionGoal = true;
  }

  private userDataForm = {
    phone: '',
    monthly_goal: 0,
  }

  private async submitCommissionGoal (commissionGoal: string) {
    this.loading = true;

    const userService = new UserService();

    const userData = await userService.getUserMyData();

    this.userDataForm = userData.body

    this.userDataForm.monthly_goal = parseInt(commissionGoal.split(",")[0].replace(".", ""))

    try {
        await userService.setUserMyData(this.userDataForm);
    } catch (error) {
        console.log(error);
        this.$store.commit("navBarAlert/WARNING_ALERT", `Error ao salvar os dados, tente mais tarde novamente.`);
    } finally {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Dados salvos com sucesso.');
        this.$router.go(0);
    }

  }

  private moneyMask: any = {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: true /* doesn't work with directive */,
  };

  private async updateDailyCommission() {
    if (this.$auth.user().id_platform && this.$auth.user().profile == "operator") {
      this.loading = true;
      const commissionServiceInstance = new CommissionService();
      const date = this.$moment().format('YYYY-MM-DD');
      await commissionServiceInstance.showDailyCommission(this.$auth.user().id_user, date)
        .then((response) => {

          if (response.commission || response.commission === 0) {
            this.dailyCommission = response.commission;
          }

          if (response.commission !== 0) {
            this.commissionBySquad = response.commissionBySquad;
            this.commissionSquadView = response.mainSquad;
          }
          this.isGoldenDay = response.isGoldenDay;

          this.loading = false;
        });
    }
  }

  private getActionsActive() {
    let ActionServiceInstance = new ActionService();
    ActionServiceInstance.indexStatus("action_active").then(
      result => {
        this.actions = result.body;
      },
      error => {
        console.log(error);
      }
    );
  }

  private async updateRanking() {
    this.rankingNivel = localStorage.getItem('ranking-painel-select') as string;

    const rankingServiceInstance = new RankingService();

    try {
        if(this.rankingNivel == 'geral')
            this.rankingList = await rankingServiceInstance.show('month');

        if(this.rankingNivel == 'vertical')
            this.rankingList = await rankingServiceInstance.show('month', this.$auth.user().id_platform);

        if(this.rankingNivel == 'platform')
            this.rankingList = await rankingServiceInstance.show('month', this.$auth.user().id_platform, true);

        let auxRankingList:any = [];
        this.rankingListLen = this.rankingList.length;

        let pos = 1;

        for (let index = 0; index < this.rankingList.length; index++) {
            if(index > 0 && this.rankingList[index].conquest_amount != this.rankingList[index - 1].conquest_amount)
                pos++;

            this.rankingList[index]['pos'] = pos;

            if(index <= 9)
                auxRankingList.push(this.rankingList[index]);

            if(this.rankingList[index]['id_user'] === this.$auth.user().id_user)
                this.myIndex = pos;

            if(index > 9 && this.rankingList[index]['id_user'] === this.$auth.user().id_user){
                auxRankingList.push(this.rankingList[index]);
                break;
            }
        }

        this.rankingList = auxRankingList;
        this.onList = this.rankingList.find(e=> e.id_user === this.$auth.user().id_user)

    } catch (error) {
        console.log(error);
    }

  }

  private updateMonthlyCommission() {
      try {
        if (this.$auth.user().id_platform && this.$auth.user().profile == "operator") {
           let commissionServiceInstance = new CommissionService();

           let month = (new Date().getMonth() + 1).toString().padStart(2, "0");
           let monthYear = month + "-" + new Date().getFullYear();

           commissionServiceInstance
            .showMonthlyCommission(monthYear, this.$auth.user().id_user)
            .then((response) => {
                if (response.commission || response.commission === 0) {
                  this.monthlyCommission = response.commission;
                }
            });
        }

      } catch (error) {

    }
  }

  private eventId = this.$bus.$on("commission_refresh", (params: any) => {
    this.updateDailyCommission();
    this.updateMonthlyCommission();
  });

  private formatMoney(value) {
    if (!value) return "0,00";

    return value.toFixed(2).toString().replace(".", ",");
  }

  /*
  * [COMMENTED] Returning money as separated in array, to be able to format
  * cents separately;
  */
  private moneyFormat (value) {
    // if (!value) return ['R$0', ',00'];

    // const currencyBRL = Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})
    // let fmtValue = currencyBRL.format(value).replace(" ", "")
    // let arr = fmtValue.split(",")
    // arr[1] = "," + arr[1]

    // return arr;

    if (!value) return 'R$ 0,00'
    else {
        const currencyBRL = Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})
        let fmtValue = currencyBRL.format(value).replace(" ", " ")
        return fmtValue
    }
  }

  private switchCommissionDisplay() {
    this.showCommission = !this.showCommission;
    this.$cookies.set(
        "showCommission", 
        this.showCommission, 
        "16h", 
        undefined, 
        undefined, 
        true, 
        "Strict"
    );
  }

  private async mounted() {
    this.isNotifAdmin = this.allowedFeature('created-notification-message') || this.notifAdminIds.includes(this.$auth.user().id_user)

    this.showCommission = JSON.parse(this.$cookies.get("showCommission"));
    const tokenValidity = JSON.parse(this.$cookies.get("tokenValidity"));

    if(!tokenValidity)
      this.logout();

    this.updateDailyCommission();
    this.updateMonthlyCommission();
    this.updateRanking();
    this.getActionsActive();

    this.$('#commission-daily-btn__BV_toggle_').removeClass("btn");
    this.$('#commission-daily-btn__BV_toggle_').removeClass("btn-secondary");
    this.$('#commission-daily-btn__BV_toggle_').removeClass("dropdown-toggle");

    this.$('#ranking-resume-navbar__BV_toggle_').removeClass("btn");
    this.$('#ranking-resume-navbar__BV_toggle_').removeClass("btn-secondary");
    this.$('#ranking-resume-navbar__BV_toggle_').removeClass("dropdown-toggle");

    this.$('#dropdown-account__BV_toggle_').removeClass("btn");
    this.$('#dropdown-account__BV_toggle_').removeClass("btn-secondary");
    this.$('#dropdown-account__BV_toggle_').removeClass("dropdown-toggle");

    this.avatar = `https://weclever-public.s3.amazonaws.com/dashboard/avatar/${this.pathAvatarSuffix}/${this.$auth.user().id_user}.jpg`
  }

  private async created() {

    let updatedDate = localStorage.getItem(this.$auth.user().platform_name + "-time-metric") != null ?
        new Date(JSON.parse(localStorage.getItem(this.$auth.user().platform_name + "-time-metric") as any)) :
        new Date();

    if (
        (localStorage.getItem(this.$auth.user().platform_name + "-hero-metric") === null ||
        this.$moment(this.$moment()).diff(this.$moment(updatedDate), 'minute') >= 2 ) &&
        this.$auth.user().profile == "operator") {
        const heroService = new HeroService();
        this.loading = true;

        try {
            this.heroMetrics = await heroService.showMetrics(this.$auth.user().id_platform, this.$auth.user().id_user);

            this.isHero = this.heroMetrics.hero;

            this.heroQuadrant = this.heroMetrics.quadrant == 'quadrant_4' ? '#00BF11' : this.heroMetrics.quadrant == 'quadrant_3' ? '#8ED203' :
                this.heroMetrics.quadrant == 'quadrant_2' ? '#F09E39' : this.heroMetrics.quadrant == 'quadrant_1' ? '#FF3300' : '#FF0000';

            this.progressQuadrant = this.heroMetrics.quadrant == 'quadrant_4' ? 100 : this.heroMetrics.quadrant == 'quadrant_3' ? 75 :
                this.heroMetrics.quadrant == 'quadrant_2' ? 50 : this.heroMetrics.quadrant == 'quadrant_1' ? 25 : 0;

            this.text1CSAT = this.heroMetrics.csat.quadrant == 'quadrant_4' ? 'Parabéns!' :
                            (this.heroMetrics.csat.quadrant == 'quadrant_3' ||  this.heroMetrics.csat.quadrant == 'quadrant_2') ? 'Continue assim!' : 'Atenção!';

            this.text1Conversion = this.heroMetrics.conversion.quadrant == 'quadrant_4' ? 'Parabéns!' : (this.heroMetrics.conversion.quadrant == 'quadrant_3' ||
                this.heroMetrics.conversion.quadrant == 'quadrant_2') ? 'Continue assim!' : 'Atenção!';

            this.text1ProductiveContact = this.heroMetrics.productiveContact.quadrant == 'quadrant_4' ? 'Parabéns!' : (this.heroMetrics.productiveContact.quadrant == 'quadrant_3' || this.heroMetrics.productiveContact.quadrant == 'quadrant_2') ? 'Continue assim!' : 'Atenção!';

            this.text2CSAT = this.heroMetrics.csat.quadrant == 'quadrant_4' ?
                `Você superou a nota ${this.heroMetrics.csat.metric}, necessária para se tornar Hero!` :
                (this.heroMetrics.csat.quadrant == 'quadrant_3' || this.heroMetrics.csat.quadrant == 'quadrant_2') ?
                    `Sua nota CSAT precisa atingir ${this.heroMetrics.csat.metric} para que você seja Hero. Faltam só ${(this.heroMetrics.csat.metric - this.heroMetrics.csat.current)} pontos!` :
                `Para ser Hero, você precisa manter sua nota CSAT acima de ${this.heroMetrics.csat.metric}. Peça ajuda do Líder Técnico.`;

            this.text2Conversion = this.heroMetrics.conversion.quadrant == 'quadrant_4' ?
                `Você superou a taxa de conversão de ${this.heroMetrics.conversion.metric}%, necessária para se tornar Hero!` :
                (this.heroMetrics.conversion.quadrant == 'quadrant_3' || this.heroMetrics.conversion.quadrant == 'quadrant_2') ?
                    `Sua taxa de conversão precisa atingir ${this.heroMetrics.conversion.metric}% para que você seja Hero. Faltam só ${(this.heroMetrics.conversion.metric - this.heroMetrics.conversion.current)}%!` :
                `Para ser Hero, você precisa manter sua taxa de conversão acima de ${this.heroMetrics.conversion.metric}%. Peça ajuda do Líder Técnico.`;

            this.text2ProductiveContact = this.heroMetrics.productiveContact.quadrant == 'quadrant_4' ?
                `Você superou os ${this.heroMetrics.productiveContact.metric} contatos finalizados, necessários para se tornar Hero!` :
                (this.heroMetrics.productiveContact.quadrant == 'quadrant_3' || this.heroMetrics.productiveContact.quadrant == 'quadrant_2') ?
                    `Seus contatos finalizados precisam atingir ${this.heroMetrics.productiveContact.metric} para que você seja Hero. Faltam só ${(this.heroMetrics.productiveContact.metric - this.heroMetrics.productiveContact.current)} contatos!` :
                `Para ser Hero, você precisa manter seus contatos finalizados acima de ${this.heroMetrics.productiveContact.metric}. Peça ajuda do Líder Técnico.`;

            localStorage.setItem(
                this.$auth.user().platform_name + "-hero-metric",
                JSON.stringify(this.heroMetrics)
            );

            localStorage.setItem(
                this.$auth.user().platform_name + "-time-metric",
                JSON.stringify(new Date())
            );

            this.isNotifAdmin = this.allowedFeature('created-notification-message') || this.notifAdminIds.includes(this.$auth.user().id_user)

        } catch(err) {
            this.loading = false;

            console.error(err);
        }
        this.loading = false;
    }else {
        this.heroMetrics = JSON.parse(localStorage.getItem(this.$auth.user().platform_name + "-hero-metric")as string);
    }

    await this.getActivePlatforms()

    await this.getNotifications()
  }

  @Watch("selected.type")
  onSelectedTypeChange() {
    let obj: any;

    obj = this.notifTypes.find(e => e.value === this.selected.type)
    this.selectedLabelType = obj.text
  }

  @Watch("selected.groups")
  onSelectedGroupsChange() {
    let objsArr: any[] = []

    this.selected.groups.forEach(selectedGroupElement =>
        objsArr.push(
            this.notifGroups.find(
                e => e.value === selectedGroupElement
            )
        )
    )

    this.selectedLabelGroups = objsArr.map(
        e => e.text
    )
  }
}
